import { AfterViewInit, ChangeDetectorRef, Component, HostListener, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import { ManagedContentService } from '../shared/service/managed-content.service';
import { UserSessionService } from '../shared/service/user-session.service';
import { CmSection, ContentType, CmQuestionGroup, CmTooltip, CmHelp } from '../shared/model/cm/managed-content.model';
import { ApplicationService } from '../shared/service/application.service';
import { ViewportScroller } from "@angular/common";
import { WindowRef } from '../shared/service/window.service';
import { DeactivateGuard } from '../deactivate.guard';
import { fromEvent, Observable, of, Subscription } from 'rxjs';
import { AppInsightsApiService} from "../shared/service/app-insights-api.service";
import { PagetitleService } from '../shared/service/pagetitle.service';
import { AuthGuardService } from '../shared/service/auth-guard.service';
import { ApplicantType } from "../shared/model/ui/applicant-type";
import { MhsService } from '../shared/service/mhs.service';
import { FormUtils } from '../shared/helper/form-utils';
import { ModalService } from '../shared/service/modal.service';
import { AppInsightsLoggerService } from '../shared/service/app-insights-logger.service';
import { MhsApplication } from '../shared/model/mhs-application';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { ReactiveFormsModule } from '@angular/forms';


@Component({
  selector: 'app-confirmation',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss'],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ConfirmationComponent implements OnInit, DeactivateGuard, AfterViewInit {

  resizeObservable$: Observable<Event>;
  resizeSubscription$: Subscription;
  public innerWidth: number = window.innerWidth;
  public printHelpPosition: string = 'top';

  public readonly pageIllustrationUrl = 'assets/Illustration-Header-Base-Mountains.svg';

  private cancelContent: CmHelp;

  public modalContentHeading: string;
  public modalContentBody: string;

  sectionTitleSection: CmSection;
  sectionTitle: string;
  confirmationMsgSection: CmSection;
  confirmationTitle: string;
  confirmationMsg: string;
  confirmationLinkSection: CmSection;
  confirmationLinkSectionTooltip: CmTooltip;
  confirmationLink: string;
  confirmationText: string;
  nextStepsSection: CmSection;
  nextStep1Section: CmSection;
  nextStep2Section: CmSection;
  nextStep3Section: CmSection;
  nextStepsBody: string;
  nextStepsTitle: string
  today: Date;
  date: string;
  period: string;
  pdfURL: string;
  tooltipHelpKeyId: string = '';
  tooltipHelpDescription: string = '';
  tooltipHelpHeading: string = '';
  policy: number;
  formNumber: string;
  mhsId: string;
  pdfId: string;
  companyId: string;
  applicantTypes: ApplicantType[];
  selectedApplicantTypes: string[];
  currentApplicantType: string;
  childCount: number;
  submittedApplicantTypes: string[] = [];
  currentChildNumber: number;
  preservedPolicyData: any;
  preservedStateData: any;
  preservedEmployeeData: any;
  preservedEdpGroupData: any;
  preservedAgencyLocation: string;
  preservedAgencyLocationLabel: string;
  preservedQuestionsData: any;
  preservedNotices: any;
  preservedIsGenericDynamicForm: boolean;

  constructor(private router: Router,
              private cmService: ManagedContentService,
              private userSessionService: UserSessionService,
              private applicationService: ApplicationService,
              private windowRef: WindowRef,
              private scroller: ViewportScroller,
              private appInsightsApiService: AppInsightsApiService,
              private pagetitleService: PagetitleService,
              private authGuardService: AuthGuardService,
              private mhsService: MhsService,
              private modalService: ModalService,
              private windowService: WindowRef,
              private appInsightsLoggerService: AppInsightsLoggerService,
              private cdref: ChangeDetectorRef) { }

  ngOnInit() {
    if(this.scroller){
      this.scroller.scrollToPosition([0,0]);
    }
    this.sectionTitleSection = this.cmService.getContentById(ContentType.SECTION, "confirmation-page");
    this.confirmationMsgSection = this.cmService.getContentById(ContentType.SECTION, "confirmation-save-pdf-msg");
    this.confirmationLinkSection = this.cmService.getContentById(ContentType.SECTION, "confirmation-print-link");
    this.confirmationLinkSectionTooltip = this.cmService.getContentById(ContentType.TOOLTIP, this.confirmationLinkSection.helpId);
    this.nextStepsSection = this.cmService.getContentById(ContentType.SECTION, "confirmation-next-steps");
  
    if(this.userSessionService.data.companyId === 'NM'){
      this.nextStepsSection = this.cmService.getContentById(ContentType.SECTION, "confirmation-next-steps-nm");
    } else {
      this.nextStepsSection = this.cmService.getContentById(ContentType.SECTION, "confirmation-next-steps");
    }

    this.sectionTitle = this.sectionTitleSection.title;
    this.sectionTitle = this.sanitize(this.sectionTitle);
    this.confirmationTitle = this.confirmationMsgSection.title;
    this.confirmationMsg = this.confirmationMsgSection.body;
    this.confirmationMsg = this.sanitize(this.confirmationMsg);

    if(this.userSessionService.data.companyId === 'NM'){
      this.cancelContent = this.cmService.getContentById(ContentType.HELP, "go-back-warning-nm");
    } else {
      this.cancelContent = this.cmService.getContentById(ContentType.HELP, "go-back-warning");
    }

    this.modalContentHeading = this.cancelContent.title;
    this.modalContentBody = FormUtils.sanitize(this.cancelContent.body);

    // Session cleanup
    // Capture values we need to retain
    this.policy = this.userSessionService.data.policy;
    this.formNumber = this.userSessionService.data.formNumber;
    this.mhsId = this.userSessionService.data.mhsId;
    this.pdfId = this.userSessionService.data.pdfId;
    this.companyId = this.userSessionService.data.companyId;
    this.applicantTypes = this.userSessionService.data.applicantTypes;
    this.selectedApplicantTypes = this.userSessionService.data.selectedApplicantTypes;
    this.currentApplicantType = this.userSessionService.data.applicantType;
    this.childCount = this.userSessionService.data.childCount || 1;
    this.submittedApplicantTypes = this.userSessionService.data.submittedApplicantTypes || [];
    this.currentChildNumber = this.userSessionService.data.currentChildNumber;
    
    // Preserve session data for continue mode
    this.preservedPolicyData = {
      policy: this.userSessionService.data.policy,
      grpName: this.userSessionService.data.grpName
    };
    this.preservedStateData = {
      state: this.userSessionService.data.state,
      country: this.userSessionService.data.country
    };
    
    this.preservedEmployeeData = {
      employee: this.userSessionService.data.employee ? { ...this.userSessionService.data.employee } : null,
      employeeMhs: this.userSessionService.data.mhsApplication?.employee ? { ...this.userSessionService.data.mhsApplication.employee } : null
    };
    
    this.preservedEdpGroupData = this.userSessionService.data.edpGroupData;
    this.preservedAgencyLocation = this.userSessionService.data.agencyLocation;
    this.preservedAgencyLocationLabel = this.userSessionService.data.agencyLocationLabel;
    
    // Preserve questions data (required for medical history page)
    this.preservedQuestionsData = this.userSessionService.data.newMhsQuestions;
    this.preservedNotices = this.userSessionService.data.notices;
    this.preservedIsGenericDynamicForm = this.userSessionService.data.isGenericDynamicForm;
    
    // Clear session
    this.userSessionService.clearSession();
    // Populate new session object with retained values
    this.userSessionService.data.policy = this.policy;
    this.userSessionService.data.formNumber = this.formNumber;
    this.userSessionService.data.mhsId = this.mhsId;
    this.userSessionService.data.pdfId = this.pdfId;
    this.userSessionService.data.companyId = this.companyId;
    this.userSessionService.data.applicantTypes = this.applicantTypes;
    this.userSessionService.data.submittedApplicantTypes = this.submittedApplicantTypes;


    this.today = new Date();
    this.date = this.today.toLocaleDateString("en-US", { month: 'numeric', day: 'numeric', year: 'numeric' });
    this.period = ".";
    this.confirmationLink = this.confirmationLinkSection.body;
    this.confirmationLink = this.sanitize(this.confirmationLink);
    this.nextStepsBody = this.nextStepsSection.body; //inner HTML
    this.nextStepsTitle = this.nextStepsSection.title;

    //Prism ToolTip
    this.tooltipHelpKeyId =  this.confirmationLinkSectionTooltip.id;
    this.tooltipHelpDescription =  this.confirmationLinkSectionTooltip.plainText;
    this.tooltipHelpHeading = this.confirmationLinkSectionTooltip.title;

    if(this.appInsightsApiService){
      this.appInsightsApiService.startNavigationEvent(this.router.url);
    }
    if(this.pagetitleService){
      this.pagetitleService.setPageTitle('Confirmation');
    }

    if(this.windowService){
      this.windowService.nativeDocument
      .querySelector('body')
      .addEventListener('click', (event: Event) => this.onClick(event));
    }
    

    //Below function runs the Qualtrics Survey
    //IMPORTANT- this needs to be at the bottom of ngOnInit() or it may break content
    this.invokeQualtrics();

    this.resizeObservable$ = fromEvent(window, 'resize')
    this.resizeSubscription$ = this.resizeObservable$.subscribe( evt => {
      this.innerWidth = window.innerWidth;
      this.changeTooltipPosition();
    });
    
  }//end ngOnInit

  ngAfterViewInit(){
    this.innerWidth = window.innerWidth;
    this.changeTooltipPosition();
  }

  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    this.pagetitleService.setPageTitle('Confirmation');

    this.modalContentHeading = this.cancelContent.title;
    this.modalContentBody = FormUtils.sanitize(this.cancelContent.body);

    this.modalService.showModal('prism-ui-modal-cancel-modal'); // Use the service to show the modal
  }

  changeTooltipPosition(){
    if(this.innerWidth < 910){
      this.printHelpPosition = 'left';
    } else {
      this.printHelpPosition = 'top';
    }
    if(this.cdref){
      this.cdref.detectChanges(); // Ensure the change is detected
    }
  }

  // Check if this is the current submitted application (just completed)
  isCurrentSubmission(applicantType: string, childNumber?: number): boolean {
    if (applicantType?.toLowerCase() === 'child' && childNumber) {
      return this.currentApplicantType?.toLowerCase() === 'child' && this.currentChildNumber === childNumber;
    }
    return applicantType?.toLowerCase() === this.currentApplicantType?.toLowerCase();
  }

  // Check if an applicant has been submitted
  isSubmitted(applicantType: string, childNumber?: number): boolean {
    if (applicantType?.toLowerCase() === 'child' && childNumber) {
      const identifier = `Child-${childNumber}`;
      return this.submittedApplicantTypes.includes(identifier);
    }
    const identifier = applicantType?.charAt(0).toUpperCase() + applicantType?.slice(1);
    return this.submittedApplicantTypes.includes(identifier);
  }

  // Check if this application was previously submitted (not current)
  isPreviouslySubmitted(applicantType: string, childNumber?: number): boolean {
    return this.isSubmitted(applicantType, childNumber) && !this.isCurrentSubmission(applicantType, childNumber);
  }

  // Check if should show action button (current submission or not started)
  shouldShowButton(applicantType: string, childNumber?: number): boolean {
    return this.isCurrentSubmission(applicantType, childNumber) || !this.isSubmitted(applicantType, childNumber);
  }

  // Get button label
  getButtonLabel(applicantType: string, childNumber?: number): string {
    return this.isCurrentSubmission(applicantType, childNumber) ? 'View PDF' : 'Start';
  }

  // Get button variant
  getButtonVariant(applicantType: string, childNumber?: number): string {
    return this.isCurrentSubmission(applicantType, childNumber) ? 'secondary' : 'primary';
  }

  // Get button icon
  getButtonIcon(applicantType: string, childNumber?: number): string {
    return this.isCurrentSubmission(applicantType, childNumber) ? 'file-pdf' : '';
  }

  // Get the card title based on applicant type
  getCardTitle(applicantType: string): string {
    return applicantType.charAt(0).toUpperCase() + applicantType.slice(1);
  }

  // Get button action handler based on applicant type
  handleCardAction(applicantType: string, childNumber?: number): void {
    if (this.isCurrentSubmission(applicantType, childNumber)) {
      // Current submission - download PDF
      this.downloadPDF();
    } else {
      // Not submitted yet - start new application
      this.startApplicationFor(applicantType, childNumber);
    }
  }

  // Start a new application for a specific applicant type
  startApplicationFor(applicantType: string, childNumber?: number): void {
    // Set continue mode flag
    this.userSessionService.data.isContinuingFromConfirmation = true;
    
    // Restore preserved data
    this.userSessionService.data.preservedPolicyData = this.preservedPolicyData;
    this.userSessionService.data.preservedStateData = this.preservedStateData;
    this.userSessionService.data.preservedEmployeeData = this.preservedEmployeeData;
    
    // Set the new applicant type and keep the selected types list
    this.userSessionService.data.applicantType = applicantType;
    this.userSessionService.data.selectedApplicantTypes = this.selectedApplicantTypes;
    this.userSessionService.data.childCount = this.childCount;
    this.userSessionService.data.submittedApplicantTypes = this.submittedApplicantTypes;
    
    // Set child number if applicable
    if (applicantType?.toLowerCase() === 'child' && childNumber) {
      this.userSessionService.data.currentChildNumber = childNumber;
    }
    
    // Restore policy and other essential data
    this.userSessionService.data.policy = this.policy;
    this.userSessionService.data.formNumber = this.formNumber;
    this.userSessionService.data.companyId = this.companyId;
    this.userSessionService.data.applicantTypes = this.applicantTypes;
    this.userSessionService.data.grpName = this.preservedPolicyData.grpName;
    
    // Clear mhsId and pdfId - each new applicant needs a fresh submission ID
    this.userSessionService.data.mhsId = '';
    this.userSessionService.data.pdfId = '';
    
    // Restore EDP group data (required for coverage page)
    this.userSessionService.data.edpGroupData = this.preservedEdpGroupData;
    this.userSessionService.data.agencyLocation = this.preservedAgencyLocation;
    this.userSessionService.data.agencyLocationLabel = this.preservedAgencyLocationLabel;
    
    // Restore questions data (required for medical history page)
    this.userSessionService.data.newMhsQuestions = this.preservedQuestionsData;
    this.userSessionService.data.notices = this.preservedNotices;
    this.userSessionService.data.isGenericDynamicForm = this.preservedIsGenericDynamicForm;
    
    // Initialize a new MhsApplication for the new applicant
    this.userSessionService.data.mhsApplication = new MhsApplication();
    this.userSessionService.data.mhsApplication.groupName = this.preservedPolicyData.grpName;
    this.userSessionService.data.mhsApplication.policyNumber = this.policy.toString();
    this.userSessionService.data.mhsApplication.isNewGenericDynamicForm = this.preservedIsGenericDynamicForm;
    if (this.preservedAgencyLocation) {
      this.userSessionService.data.mhsApplication.adminUnit = this.preservedAgencyLocation;
    } else {
      this.userSessionService.data.mhsApplication.adminUnit = '0';
    }
    
    // Navigate to consent page (first manual entry page in workflow)
    this.router.navigate(['/consent']);
  }

  // Generate array for child count loop
  getChildArray(): number[] {
    const count = this.childCount || 1;
    return Array.from({ length: count }, (_, i) => i + 1);
  }

  // Get count of completed applications
  getCompletedCount(): number {
    return this.submittedApplicantTypes.length;
  }

  // Get total number of applications selected
  getTotalCount(): number {
    let total = 0;
    this.selectedApplicantTypes?.forEach(type => {
      if (type?.toLowerCase() === 'child') {
        total += this.childCount;
      } else {
        total += 1;
      }
    });
    return total;
  }

  downloadPDF() {
    this.applicationService.getCloudApplicationPdf(
      this.userSessionService.data.formNumber,
      this.userSessionService.data.mhsId,
      this.userSessionService.data.pdfId)
    .subscribe((response: BlobPart) => {
      let file = new Blob([response], { type: 'application/pdf' });
      let fileURL = URL.createObjectURL(file);
      window.open(fileURL);
    });
  }

  //Drupal inserts <p> tag to body of Json objects that is not supposed to have any HTML tags in it
  //This function clears out all HTML tags that might have been inserted into the content
  sanitize(str : String){
    return str.replace(/<[^>]*>/g, '');
  }

  public startAnotherStatement(): void {
    this.clearSessionData();
    this.userSessionService.clearSession();
    // Set sessionEnded AFTER clearSession to prevent it from being cleared
    this.userSessionService.data.sessionEnded = true;
    this.authGuardService.cancelLeaveAnyway();
    this.router.navigate(['/instructions']);
  }

  clearSessionData(){
    this.userSessionService.data.answeredYesToRequiredPhysicianQuestion = null;
    this.userSessionService.data.formNumber = null;
    this.userSessionService.data.hasFraudNotice = null;
    this.userSessionService.data.isGenericDynamicForm = null;
    this.userSessionService.data.mhsId = null;
    this.userSessionService.data.pdfId = null;
    this.userSessionService.data.submittedApplicantTypes = [];
  }

  invokeQualtrics(){
    if(this.windowRef){
      this.windowRef.nativeWindow.QSI.API.unload();
      this.windowRef.nativeWindow.QSI.API.load();
      this.windowRef.nativeWindow.QSI.API.run();
    }
  }

  // use the window service to access the modal element
  // and close the modal when the user clicks outside of it
  onClick(event: Event) {
    const modal = this.windowService.nativeDocument.getElementById(
      'prism-ui-modal-cancel-modal'
    );

    if (modal && event.target === modal) {
      this.onCancelModal('prism-ui-modal-cancel-modal');
    }
  }

  leaveAnyway(){
    this.userSessionService.clearSession();
    this.userSessionService.data.sessionEnded = true;
    this.authGuardService.cancelLeaveAnyway();
    this.router.navigate(['/instructions']);
  }

  onCancelModal(modalName: string){
    const modalElement =
      this.windowService.nativeDocument.getElementById(modalName);

    if (modalElement && modalElement.close) {
      modalElement.close();
    } else {
      this.appInsightsLoggerService.log('info', 'Info log from Confirmation.component', `Modal with id ${modalName} not found or doesn't support close method.`);
    }
  }

  canDeactivate(){
    // Skip cancel modal when continuing to new application
    if (this.userSessionService.data.isContinuingFromConfirmation) {
      return of(true);
    }
    
    if (!this.userSessionService.data.sessionEnded) {
      this.modalService.showModal('prism-ui-modal-cancel-modal'); // Use the service to show the modal
      return of(false);
    } else {
      return of(true);
    }
  }

}
